function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useState, useEffect, useContext, useCallback, memo } from 'react';
import AsyncSelect from 'react-select/async';
import { FormGroup } from 'reactstrap';
import { WeverCoreContext, _translate } from "../../services/core";
import Api from "../../services/api";
var Autocomplete = function Autocomplete(props) {
  // props
  var display = props.display,
    name = props.name,
    size = props.size,
    multiple = props.multiple,
    filters = props.filters,
    clearable = props.clearable,
    min_character_search = props.min_character_search,
    value = props.value,
    hasLabel = props.hasLabel,
    onChange = props.onChange,
    autoload = props.autoload,
    placeholder = props.placeholder,
    defaultOption = props.defaultOption,
    urlResource = props.urlResource,
    disabled = props.disabled,
    _props$cache = props.cache,
    cache = _props$cache === void 0 ? true : _props$cache,
    _props$groupClassName = props.groupClassName,
    groupClassName = _props$groupClassName === void 0 ? '' : _props$groupClassName,
    _props$noOptionsMessa = props.noOptionsMessage,
    noOptionsMessage = _props$noOptionsMessa === void 0 ? function () {
      return _translate('collectorapp_no_options');
    } : _props$noOptionsMessa,
    _props$loadingMessage = props.loadingMessage,
    loadingMessage = _props$loadingMessage === void 0 ? function () {
      return _translate('collectorapp_search_options');
    } : _props$loadingMessage,
    className = props.className,
    key = props.key;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  // state
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    timer = _useState4[0],
    setTimer = _useState4[1];
  // var
  var invalid = false;
  /**
   * Format value or received options (from api)
   * used in fetchOptions and useEffect.
   *
   * @param {array} collection
   */
  var formatCollectionToOptions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(collection, isMultiple) {
      var isSettingValue,
        response,
        objCollection,
        i,
        entity,
        _response,
        _labelToDisplay,
        _labelToDisplay2,
        obj,
        labelToDisplay,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isSettingValue = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            if (!Array.isArray(collection) && (multiple || isMultiple)) {
              collection = [collection];
            }
            response = null;
            if (!(multiple || isMultiple)) {
              _context.next = 32;
              break;
            }
            objCollection = [];
            if (defaultOption) {
              objCollection.push(defaultOption);
            }
            i = 0;
          case 7:
            if (!(i < collection.length)) {
              _context.next = 28;
              break;
            }
            if (!(_typeof(collection[i]) === 'object')) {
              _context.next = 21;
              break;
            }
            entity = collection[i];
            if (entity['_id']) {
              entity.id = entity['_id'];
            }
            if (!(!entity[display] && entity['id'])) {
              _context.next = 16;
              break;
            }
            _context.next = 14;
            return Api.get(entity['id']);
          case 14:
            _response = _context.sent;
            entity = _response.data;
          case 16:
            _labelToDisplay = entity[display];
            if (_typeof(_labelToDisplay) === 'object') {
              _labelToDisplay = _labelToDisplay[locale];
            }
            objCollection.push({
              label: _labelToDisplay,
              value: entity
            });
            _context.next = 25;
            break;
          case 21:
            _context.next = 23;
            return Api.get(collection[i]);
          case 23:
            response = _context.sent;
            if (response.data) {
              _labelToDisplay2 = response.data;
              if (_typeof(_labelToDisplay2) === 'object') {
                _labelToDisplay2 = response.data[locale];
              }
              objCollection.push({
                label: _labelToDisplay2,
                value: response.data
              });
            }
          case 25:
            i++;
            _context.next = 7;
            break;
          case 28:
            if (!isSettingValue) {
              _context.next = 31;
              break;
            }
            setValues(objCollection);
            return _context.abrupt("return");
          case 31:
            return _context.abrupt("return", objCollection);
          case 32:
            obj = collection;
            if (!(_typeof(collection) !== 'object')) {
              _context.next = 38;
              break;
            }
            _context.next = 36;
            return Api.get(collection);
          case 36:
            response = _context.sent;
            if (response.data) {
              obj = response.data;
            }
          case 38:
            labelToDisplay = obj[display];
            if (_typeof(labelToDisplay) === 'object') {
              labelToDisplay = labelToDisplay[locale];
            }
            if (isSettingValue) {
              setValues({
                label: _translate(labelToDisplay || ''),
                value: obj
              });
            }
            return _context.abrupt("return", {
              label: _translate(labelToDisplay || ''),
              value: obj
            });
          case 42:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function formatCollectionToOptions(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * @param {string} terms
   */
  var fetchOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(terms) {
      var filtersList, response, allOptions;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            filtersList = _objectSpread(_objectSpread({}, filters), {}, {
              text: terms,
              locale: locale
            });
            _context2.next = 4;
            return Api.get("".concat(urlResource), filtersList);
          case 4:
            response = _context2.sent;
            allOptions = _toConsumableArray(response.data);
            return _context2.abrupt("return", formatCollectionToOptions(allOptions, true));
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", []);
          case 12:
            return _context2.abrupt("return", []);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return function fetchOptions(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * @param {string} value
   */
  var loadAsyncOptions = useCallback(function (terms) {
    clearTimeout(timer);
    return new Promise(function (resolve) {
      var newTimer = setTimeout(function () {
        resolve(fetchOptions(terms));
      }, 550);
      setTimer(newTimer);
    });
  }, [key]);

  /**
   * @param {array} options
   */
  var handleOnChange = function handleOnChange(options) {
    if (!options) {
      setValues([]);
      return;
    }
    var optionsToValue = [];
    if (multiple) {
      options.forEach(function (option) {
        if (option.value) {
          optionsToValue.push(option.value['id']);
        }
      });
    } else {
      if (options.value) {
        var valueOption = options.value['id'];
        optionsToValue = valueOption;
      }
    }
    setValues(options);
    if (onChange && typeof onChange === 'function') {
      onChange(optionsToValue, options);
    }
  };
  useEffect(function () {
    if (!value || typeof value === 'string') {
      return;
    }
    formatCollectionToOptions(value, multiple, true);
  }, [value]);
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: "w-100 ".concat(groupClassName)
  }, name && hasLabel && /*#__PURE__*/React.createElement("div", {
    name: name,
    size: size
  }), /*#__PURE__*/React.createElement(AsyncSelect, {
    key: key,
    isMulti: multiple,
    isClearable: clearable,
    cacheOptions: cache,
    loadOptions: loadAsyncOptions,
    invalid: invalid,
    onChange: handleOnChange,
    value: values,
    defaultOptions: true,
    className: "autocomplete-async ".concat(disabled ? 'disabled' : '', " ").concat(className),
    placeholder: placeholder || _translate('collectorapp_autocomplete_select'),
    isDisabled: disabled,
    noOptionsMessage: noOptionsMessage,
    loadingMessage: loadingMessage,
    size: "sm"
  }));
};
Autocomplete.propTypes = {
  size: PropTypes.string,
  resource: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  tag: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
  autoload: PropTypes.bool,
  hasLabel: PropTypes.bool
};
Autocomplete.defaultProps = {
  size: 'sm',
  multiple: false,
  clearable: false,
  autoload: false,
  hasLabel: true,
  name: null,
  value: null
};
export default /*#__PURE__*/memo(Autocomplete);